<template>
  <v-card height="80vh" max-height="80vh">
    <v-card-title>Site Cached Metrics</v-card-title>

    <v-divider></v-divider>

    <v-card-text style="height: calc(100% - (53px + 59px)); overflow-x: auto;">

        <v-btn class="previous-button" icon @click="previous"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn class="next-button" icon @click="next"><v-icon>mdi-chevron-right</v-icon></v-btn>

        <v-window v-model="siteNumber" style="padding: 5px 30px;">

            <v-window-item v-for="(alarmSite, index) in $props.alarmSites" :key="alarmSite.siteId">

                <div class="site-info-container">
                    <template v-if="alarmSite.siteId">
                        <span class="title">{{ `Site Name: ${alarmSite.siteName}, Office: ${alarmSite.alarms[0].alarm_office}, Location: ${alarmSite.alarms[0].alarm_location}` }}</span>
                    </template>
                    <template v-if="!alarmSite.siteId">
                        <span class="title">No Matching Site</span>
                    </template>
                </div>

                <div class="section">
                    <span class="sub-title">Alarms</span>
                    <v-simple-table light dense fixed-header>
                        <thead><tr>
                            <th class="text-left">When</th>
                            <th class="text-left">Severity</th>
                            <th class="text-left">Description</th>
                            <th class="text-left">Rep</th>
                            <th class="text-left">Ack</th>
                            <th class="text-left">Clear</th>
                            <th class="text-left">Service Affecting</th>
                        </tr></thead>
                        <tr v-for="alarm in alarmSite.alarms" :style="alarmRowColor(alarm)">
                            <td>{{ alarm.alarm_time }}</td>
                            <td>{{ alarm.alarm_severity }}</td>
                            <td>{{ alarm.alarm_description }}</td>
                            <td>{{ alarm.alarm_repeats }}</td>
                            <td>{{ alarm.alarm_ack_time ? 'Yes': 'No' }}</td>
                            <td>{{ alarm.alarm_clear_time ? 'Yes': 'No' }}</td>
                            <td>{{ alarm.alarm_service_affecting == 't' ? 'Yes': 'No' }}</td>
                        </tr>
                    </v-simple-table>
                </div>

                <div class="section" :style="{height: (alarmSite.siteThresholdMetricsObjectData && alarmSite.siteThresholdMetricsObjectData.siteThresholdMetrics) ? '500px' : '0px'}">
                    <span class="sub-title">
                        Metrics Data
                        <v-icon small v-if="gettingSiteThresholdMetrics">fas fa-spinner fa-spin</v-icon>
                    </span>
                    
                    <!-- <map-item-site-threshold-metrics :siteThresholdMetrics="alarmSite.siteThresholdMetrics" :gettingSiteThresholdMetrics="gettingSiteThresholdMetrics" /> -->
                    <map-item-site-threshold-metrics :infoWindowData="alarmSite.siteThresholdMetricsObjectData" :gettingSiteThresholdMetrics="gettingSiteThresholdMetrics" v-if="!gettingSiteThresholdMetrics" />
                </div>

                <div class="section">
                    <span class="sub-title">
                        Metrics Charts
                        <v-icon small v-if="gettingSiteThresholdMetrics">fas fa-spinner fa-spin</v-icon>
                    </span>
                    <!-- <map-item-site-threshold-metrics-chart :siteThresholdMetrics="alarmSite.siteThresholdMetrics" :gettingSiteThresholdMetrics="gettingSiteThresholdMetrics" :useDialog="true" /> -->
                    <map-item-site-threshold-metrics-chart :infoWindowData="alarmSite.siteThresholdMetricsObjectData" :gettingSiteThresholdMetrics="gettingSiteThresholdMetrics" :useDialog="true" />
                </div>
                
            

            </v-window-item>

        </v-window>
        
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text @click="$emit('close')">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { rowColorFuncs } from "@/components/Alarms/AlarmFuncs";
import MapItemSiteThresholdMetrics from "@/components/GeoMap/MapItemSiteThresholdMetrics";
import MapItemSiteThresholdMetricsChart from "@/components/GeoMap/MapItemSiteThresholdMetricsChart";
export default {
    name: 'SiteCachedMetrics',
    props: ['alarmSites'],
    components: {
        MapItemSiteThresholdMetrics,
        MapItemSiteThresholdMetricsChart
    },
    data: () => ({
        siteNumber: 0,
        siteThresholdMetrics: null,
        gettingSiteThresholdMetrics: true,
    }),

    computed: {
    },

    methods: {
        previous: function() {
            this.siteNumber = (this.siteNumber == 0) ? this.$props.alarmSites.length - 1 : this.siteNumber - 1;
        },

        next: function() {
            this.siteNumber = (this.siteNumber + 1 != this.$props.alarmSites.length) ? this.siteNumber + 1 : 0;
        },

        alarmRowColor: function(alarm) {
            let colors = rowColorFuncs.getRowColor({data: alarm}, this.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
            return {backgroundColor: colors.background, color: colors.color};
        },

        getMetrics: function() {
            let route = (TELSA.apiHost + "sites/site/thresholdmetrics");
            let sites = this.$props.alarmSites.filter(as => as.siteId);
            this.gettingSiteThresholdMetrics = true;
            return this.$http.post(route, {args: {sites: sites}}).then(response => {
                let results = response.body;
                for(let result of results) {
                    //this.$props.alarmSites.find(as => as.siteId == result.siteId).siteThresholdMetrics = result.siteThresholdMetrics;
                    this.$props.alarmSites.find(as => as.siteId == result.siteId).siteThresholdMetricsObjectData = {
                        siteThresholdMetrics: result.siteThresholdMetrics,
                        filteredSiteThresholdMetrics: result.siteThresholdMetrics,
                        siteThresholdMetricsFilters: {},
                        siteThresholdMetricsGroupByType: null
                    };
                }
                this.gettingSiteThresholdMetrics = false;
            });
        },

        keyHandler: function(k) {
            if(k.key == 'ArrowRight') {
                this.next()
            }
            else if(k.key == 'ArrowLeft') {
                this.previous();
            }
        }

    },

    mounted() {
        console.log('alarmSites: ', this.$props.alarmSites);
        this.getMetrics();
        document.addEventListener('keydown', this.keyHandler);
    },

    destroyed() {
        document.removeEventListener('keydown', this.keyHandler);
    }

  
};
</script>

<style scoped>

    .previous-button {
        position: absolute;
        top: 45%;
        left: 5px;
    }

    .next-button {
        position: absolute;
        top: 45%;
        right: 5px;
    }

    .site-info-container {
        margin-bottom: 10px;
    }

    .site-info-container .title {
        color: #FFFFFF;
        font-size: 24px;
    }

    .section {
        border: #000000 solid 1px;
        background-color: #303030;
        border-radius: 5px;
        padding: 10px 15px 40px 15px;
        margin-bottom: 15px;
    }

    .section .sub-title {
        display: block;
        margin-bottom: 3px;
    }
    .section .sub-title  i {
        vertical-align: text-top;
    }

</style>
